import { Chip } from "@mui/material";
import { staffActiveStatusLabel } from "../staff-active-helpers";

/** Soft active status chip for staff list / dashboard (theme palette colors). */
export function StaffActiveStatusChip({ isActive }: { isActive?: boolean | null }) {
  const inactive = isActive === false;
  return (
    <Chip
      size="small"
      label={staffActiveStatusLabel(isActive)}
      color={inactive ? "default" : "success"}
      variant={inactive ? "outlined" : "filled"}
    />
  );
}
